import { Space } from "antd";
import React from "react";
import { Style } from "../style";

export function BtnGroup({ children, vertical }: { children: React.ReactNode; vertical?: boolean }) {
  return (
    <Space size={vertical ? 20 : 40} className={Style.buttonGroup} direction={vertical ? "vertical" : "horizontal"}>
      {children}
    </Space>
  );
}
